var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4, _rect5, _rect6, _rect7, _path5, _path6, _path7, _path8, _path9, _path10, _line, _line2, _line3, _line4, _line5, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpInvitationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f,.i{fill:none;}.b,.j{fill:#3c3c46;}.b{opacity:0.15;}.c{fill:#e5e5e5;}.c,.f,.g,.i,.k{stroke:#3c3c46;stroke-linejoin:round;stroke-width:2px;}.c,.f,.g,.i{stroke-linecap:round;}.c,.g,.h,.i,.j,.k{fill-rule:evenodd;}.d,.g,.h{fill:#fff;}.e{fill:#ffefe0;}.k{fill:#f2424c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-invitation-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 32.73,
    y: 36.67,
    width: 86.52,
    height: 57.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M94.16,87.48V91h0a4,4,0,0,0,7.87,0h0V87.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M45.84,87.48V91h0a4,4,0,0,1-7.87,0h0V87.48Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M102.07,87.48v1.76h0a4,4,0,0,0,7.87,0h0l-.86-1.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M37.92,87.48v1.76h0a4,4,0,0,1-7.87,0h0l.86-1.76Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 26.73,
    y: 30.67,
    width: 86.54,
    height: 57.85
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 70,
    y: 30.67,
    width: 43.27,
    height: 57.85
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 26.73,
    y: 30.67,
    width: 86.54,
    height: 57.85
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 94.16,
    y: 78.85,
    width: 11.98,
    height: 8.63
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 33.86,
    y: 78.85,
    width: 11.98,
    height: 8.63
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M121,64h-7.78l-.18,19.31-13.47-7.7,0,0a4,4,0,0,0-3.94,6.81l0,0L108.36,91l1,5a6.53,6.53,0,0,0,6.42,5.42l.58,2.08L131,104.9l-3.13-34.69A6.89,6.89,0,0,0,121,64Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M19,64h7.78l.18,19.31,13.47-7.7,0,0a4,4,0,0,1,3.94,6.81l0,0L31.64,91l-1,5a6.53,6.53,0,0,1-6.42,5.42l-.58,2.08L9,104.9l3.13-34.69A6.89,6.89,0,0,1,19,64Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M108.43,109.33v-6.8a1.1,1.1,0,0,1,1.09-1.09H132a1.1,1.1,0,0,1,1.09,1.09v6.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M31.57,109.33v-6.8a1.1,1.1,0,0,0-1.09-1.09H8a1.1,1.1,0,0,0-1.09,1.09v6.8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M108.43,109.33v-6.8a1.1,1.1,0,0,1,1.09-1.09H132a1.1,1.1,0,0,1,1.09,1.09v6.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M31.57,109.33v-6.8a1.1,1.1,0,0,0-1.09-1.09H8a1.1,1.1,0,0,0-1.09,1.09v6.8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 44.97,
    y1: 58.87,
    x2: 95.02,
    y2: 58.87
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 44.97,
    y1: 68.87,
    x2: 95.02,
    y2: 68.87
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 85.91,
    y1: 63.87,
    x2: 95.02,
    y2: 63.87
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 44.97,
    y1: 63.87,
    x2: 61.26,
    y2: 63.87
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 67.69,
    y1: 63.87,
    x2: 76.81,
    y2: 63.87
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M73.91,81.53a.82.82,0,0,1-.78-1.08,2.26,2.26,0,0,0,.1-.56,3.43,3.43,0,0,1-2,1.59,2.2,2.2,0,0,1-2.18-.82c-1.36-1.5-.43-3.18.24-4.41.8-1.45.77-1.68.34-2a1.64,1.64,0,0,0-1.31.07c-2.62,1-6.2,4.94-6.5,6a.82.82,0,1,1-1.58-.46c.49-1.68,4.54-6,7.51-7.05a3,3,0,0,1,2.78.09,2.08,2.08,0,0,1,1,2.19A6.4,6.4,0,0,1,70.77,77c-.93,1.7-.85,2.08-.47,2.51s.54.34.61.32c.49-.11,1.28-1.11,1.75-2.61a.82.82,0,0,1,1.49-.18,5.67,5.67,0,0,1,.6,1.52,12.68,12.68,0,0,0,.64-1.5.82.82,0,0,1,1.26-.38,4.11,4.11,0,0,1,1.7,2.65,2.4,2.4,0,0,1-.77,1.91.82.82,0,0,1-1.16-1.16.77.77,0,0,0,.29-.63,1.36,1.36,0,0,0-.26-.64,4.89,4.89,0,0,1-2.19,2.59A.82.82,0,0,1,73.91,81.53Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M63.15,83.86h0a.82.82,0,0,1-.78-.86c0-.92,1.39-2.62,1.66-3,.8-1,2-2.2,3.1-2.35a.82.82,0,1,1,.22,1.63,4.78,4.78,0,0,0-2,1.65A8.48,8.48,0,0,0,64,83.11.82.82,0,0,1,63.15,83.86Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M81.54,41.48a3.86,3.86,0,0,0-7.15-2,3.86,3.86,0,1,0-5.82,4.92L74,49.85a.5.5,0,0,0,.7,0l5.47-5.47a3.88,3.88,0,0,0,1-1.28A3.83,3.83,0,0,0,81.54,41.48Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M72.75,45.45a3.86,3.86,0,0,0-7.15-2,3.86,3.86,0,1,0-5.82,4.92l5.47,5.47a.5.5,0,0,0,.7,0l5.47-5.47a3.88,3.88,0,0,0,1-1.28A3.83,3.83,0,0,0,72.75,45.45Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpInvitationIcon);
export default __webpack_public_path__ + "static/media/CP-invitation-icon.a2743edac14e44fa95407f6a2abe4f92.svg";
export { ForwardRef as ReactComponent };